import React from "react";
import ContactoLayout from "./content/Contacto.layout";
import EquipoLayout from "./content/Equipo.layout";
import JuegosLayout from "./content/Juegos.layout";


const ContentLayout = () => {
    return (
        <body>
            <JuegosLayout></JuegosLayout>
            <EquipoLayout></EquipoLayout>
            <ContactoLayout></ContactoLayout>
        </body>
    );
};

export default ContentLayout;
